// src/utils/anchorVoices.js
// ElevenLabs Multilingual v2 음성 ID 매핑.
// TODO(citizencast): ElevenLabs 대시보드에서 한/영/일 음성 4종씩 생성 후 실제 Voice ID로 교체.

export const ANCHOR_VOICES = {
  KR: {
    neutral: 'uyVNoMrnUku1dZyVEXwD',
    angry:   '2gbExjiWDnG1DMGr81Bx',
    appeal:  'AW5wrnG1jVizOYY7R1Oo',
    dry:     'MpbDJfQJUYUnp0i1QvOZ',
  },
  US: {
    neutral: '9fHP3GqJWwJmIbYQwQ1V',
    angry:   '6FiCmD8eY5VyjOdG5Zjk',
    appeal:  'nf4MCGNSdM0hxM95ZBQR',
    dry:     'IHw7aBJxrIo1SxkG9px5',
  },
  JP: {
    neutral: 'C8e2F6Cm3l58PjXaVpUW',
    angry:   '17ljzcHzSunXNkdixIEa',
    appeal:  'fUjY9K2nAIwlALOwSiwc',
    dry:     'pfzojrOPPpo9eObivQXJ',
  },
};

export const EMOTION_LABELS = {
  neutral: { ko: '기본',     en: 'Neutral',  ja: 'ニュートラル' },
  angry:   { ko: '분노',     en: 'Angry',    ja: '怒り' },
  appeal:  { ko: '호소',     en: 'Appeal',   ja: '訴え' },
  dry:     { ko: '건조',     en: 'Dry',      ja: 'ドライ' },
};
